import { Option } from 'pages/PractitionerPage/MainSection/PractitionerProfile/MultipleSelect/MultipleSelect';
import OperatoryDropdown from 'pages/PractitionerPage/MainSection/PractitionerProfile/OperatoryDropdown/OperatoryDropdown';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { Props } from 'react-select';

interface OperatoryDropdownWrapperProps {
  onUpdate: (newValue: string[]) => void;
  value: Option[];
  selectProps?: Props;
}

const OperatoryDropdownWrapper: FC<OperatoryDropdownWrapperProps> = ({
  onUpdate,
  value,
  selectProps,
}) => {
  const { control } = useForm<{
    operatories: { value: string; label: string }[];
  }>({
    mode: 'all',
    values: {
      operatories: value ?? [],
    },
  });

  return (
    <OperatoryDropdown
      controlStyles={{
        height: '4rem',
        minHeight: '0',
      }}
      control={control}
      onUpdate={onUpdate}
      rules={{
        validate: (value) =>
          value.length > 0 ? true : 'This field is required',
      }}
      selectProps={selectProps}
    />
  );
};

export default OperatoryDropdownWrapper;
